<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="my-wrap container">
      <titleConfig
        :title="langSet == 'cn' ? '我的收藏' : 'My Favorites'"
        :type="2"
      ></titleConfig>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="langSet == 'cn' ? '产品' : 'Products'" name="1">
          <productList
            v-if="list"
            :productLists="list"
            :external="'product'"
          ></productList>
          <nodata v-if="list.length == 0"></nodata>
        </el-tab-pane>
        <el-tab-pane :label="langSet == 'cn' ? '企业' : 'Companies'" name="2">
          <companyList
            v-if="list"
            :companyLists="list"
            :external="'company'"
          ></companyList>
          <nodata v-if="list.length == 0"></nodata>
        </el-tab-pane>
        <el-tab-pane :label="langSet == 'cn' ? '活动' : 'Events'" name="3">
          <active
            v-if="list"
            :list="list"
            :type="'3'"
            :external="'active'"
          ></active>
          <nodata v-if="list.length == 0"></nodata>
        </el-tab-pane>
        <el-tab-pane
          :label="langSet == 'cn' ? '商机' : 'Business Opportunities'"
          name="4"
        >
          <Business_list
              v-if="list"
              :external="'business'"
              :businessList="list"
          ></Business_list>
          <nodata v-if="list.length == 0"></nodata>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>


<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import productList from "../product/component/product_list.vue";
import companyList from "../company/component/company_list.vue";
import active from "@/components/active.vue";
import nodata from "@/components/nodata.vue";
import { collectList } from "@/api/api";
import Business_list from "@/views/business/component/business_list.vue";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.title,
      meta: [
        {
          name: "description",
          content: this.metaData.desc,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    Business_list,
    top,
    bottom,
    titleConfig,
    productList,
    companyList,
    active,
    nodata,
  },
  data() {
    return {
      langSet: "",
      metaData: {},
      activeName: "1",
      list: [],
    };
  },
  created() {},
  mounted() {
    this.metaData = JSON.parse(localStorage.getItem("metaData"));
    this.langSet = this.$language;
    //25.9.24 获取产品收藏列表 dxm
    this.getCollect();
  },
  methods: {
    async getCollect() {
      let data = {
        type: this.activeName,
      };
      const res = await collectList(data);
      this.list = res.data.lists;
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.list = [];
      this.getCollect();
    },
  },
};
</script>


<style scoped lang="scss">
.my-wrap {
  padding: 80px 0;
  .title_wrap {
    margin-bottom: 30px;
  }
}
/deep/ .el-tabs {
  min-height: 500px;
}
/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
/deep/ .el-tabs__header {
  margin-bottom: 30px;
}
/deep/ .el-tabs__item {
  min-width: 120px;
  height: 42px;
  padding: 0 10px !important;
  font-weight: 400;
  font-size: 16px;
  color: #444;
  line-height: 42px;
  text-align: center;
  background: #eee;
  margin-right: 20px;
  border-radius: 21px;
  box-sizing: border-box;
}
/deep/ .el-tabs__active-bar {
  display: none;
}
/deep/ .el-tabs__item.is-active {
  color: #fff;
  font-weight: 500;
  background: #1d2379;
}
@media only screen and (max-width: 767px) {
  .my-wrap {
    padding: 0.58rem 0;
    /deep/ .el-tabs__item {
      width: 1.71rem;
      height: 0.65rem;
      font-size: 0.27rem;
      line-height: 0.65rem;
      margin-right: 0.29rem;
    }
    /deep/ .el-tabs__nav-next, 
    /deep/ .el-tabs__nav-prev{
      line-height: 35px;
    }
  }
}
</style>